<template>
  <v-dialog v-model="dialog" persistent scrollable width="600">
    <v-card>
      <v-card-title class="blue darken-4 white--text text-uppercase">
        Xếp lớp
        <v-spacer />
        <v-icon color="white" @click="closeDialog">mdi-close</v-icon>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6">
        <div class="mb-3 text-body-1 black--text">1. Thông tin hồ sơ</div>
        <div class="mb-1">
          Mã hồ sơ: <strong>{{ $get(item, 'code') }}</strong>
        </div>
        <div class="mb-1">
          Tên thí sinh: <strong>{{ $get(item, 'cv.name') }}</strong>
        </div>
        <div class="mb-1">
          Điểm Ngôn ngữ: <strong>{{ $get(item, 'cv.ltvExamResult.examLanguage') }}</strong>
        </div>
        <div class="mb-1">
          Điểm Tư duy: <strong>{{ $get(item, 'cv.ltvExamResult.examMathMark') }}</strong>
        </div>
        <div class="mb-1">
          Tổng điểm: <strong>{{ $get(item, 'cv.ltvExamResult.examTotal') }}</strong>
        </div>
        <div class="mb-1">
          Đã xếp lớp: <strong>{{ $get(item, 'assignedClassTitle', '-Chưa được xếp lớp-') }}</strong>
        </div>
        <v-divider class="my-3" />
        <div class="mb-3 text-body-1 black--text">2. Thông tin xếp phòng</div>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" class="pb-0">
              <v-autocomplete
                :items="classes"
                v-model="assignedClass"
                placeholder="Lớp được xếp"
                clearable
                flat
                outlined
                dense
                hide-detail
                item-text="title"
                item-value="id"
              >
                <template v-slot:item="{item}">
                  <div class="d-flex align-center" style="gap: 16px">
                    {{ item.title }}
                    <div class="text-caption text-uppercase d-flex justify-end" style="gap: 8px">
                      <div>
                        Nhập học: <span class="text-body-2">{{ item.enrollCount }}</span>
                      </div>
                      <div>
                        Đã xếp: <span class="text-body-2">{{ item.count }}</span>
                      </div>
                      <div class="red--text">
                        Giới hạn: <span class="text-body-2">{{ $get(item, 'limit', '-') }}</span>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-slot:selection="{item}">
                  <div class="d-flex align-center" style="gap: 16px">
                    {{ item.title }}
                    <div class="text-caption text-uppercase d-flex justify-end" style="gap: 8px">
                      <div>
                        Nhập học: <span class="text-body-2">{{ item.enrollCount }}</span>
                      </div>
                      <div>
                        Đã xếp: <span class="text-body-2">{{ item.count }}</span>
                      </div>
                      <div class="red--text">
                        Giới hạn: <span class="text-body-2">{{ $get(item, 'limit', '-') }}</span>
                      </div>
                    </div>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn outlined @click="closeDialog">Huỷ</v-btn>
        <v-btn color="admin" class="white--text" @click="onSubmit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapActions} from 'vuex'
import {get} from 'lodash'
export default {
  data: () => ({dialog: false, item: null, classes: [], assignedClass: null, loading: false}),
  methods: {
    ...mapActions({
      fetchClassesIndependent: 'assignClass/fetchClassesIndependent',
      updateAssignClass: 'assignClass/updateAssignClass',
    }),
    async openDialog(item = {}) {
      this.item = item
      this.assignedClass = get(item, 'assignedClass', null)
      this.classes = await this.fetchClassesIndependent({type: 'Khối 10'})
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.reset()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    async onSubmit() {
      this.loading = true
      if (!this.assignedClass) return this.$alert.error('Vui lòng chọn lớp')
      if (this.item.assignedClass && this.item.assignedClass === this.assignedClass)
        return this.$alert.error('Nếu không đổi xin đừng chọn lại')
      try {
        await this.updateAssignClass({id: this.item.id, ecId: this.assignedClass})
        this.$emit('onRefresh')
        this.$alert.success('Xếp lớp thành công')
        this.closeDialog()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>